export default "__VITE_ASSET__CK65kqv2__"